<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">服务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">我的工单</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">工单列表</div>
      </div>
      <div class="panel-body clearfix">
        <div class="ub-box z-margin-bottom-20-precent">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="submitGongdan">提交工单</el-button>
          <div class="zj-select" style="margin-left: 25px">
            <el-input placeholder="关键词" v-model="search" class="input-with-select" @keyup.enter.native="SearchGongdan">
              <el-select v-model="key_type" slot="prepend" placeholder="全部">
                <el-option label="工单编号" value="id"></el-option>
                <el-option label="工单内容" value="gd_content"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="SearchGongdan"></el-button>
            </el-input>
          </div>
        </div>
        <el-table :data="gongdanList" highlight-current-row tooltip-effect="light" v-loading="listLoading" @sort-change="sort" style="width: 100%;">
          <el-table-column prop="id" label="工单编号" align="left">
          </el-table-column>
          <el-table-column prop="content" label="工单内容" align="left" max-width="300" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="type" label="问题类型" align="center">
          </el-table-column>
          <el-table-column prop="time" label="提交时间" align="left" sortable="custom">
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center">
          </el-table-column>
          <el-table-column prop="cuidan" label="催单" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.cbtn && scope.row.state != '已结束'" class="z-curPonit z-color-a" @click="Cuidan(scope.row.id)">催单</span>
              <span v-if="!scope.row.cbtn && scope.row.ctime != ''">已催单 {{scope.row.ctime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="caozuo" label="操作" align="center">
            <template slot-scope="scope">
              <span class="z-curPonit z-color-a" @click="Chakan(scope.row.id)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import gongdanService from 'business/gongdanService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        gongdanList:[],
        listLoading:false,
        dialogLoading:false,
        search:'',
        key_type:'id',
        orderby:'gd_time',
        ordertype:'desc',
        count:10,
        total:0,
        page:1,
      }
    },
    components:{
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchGongdan()
    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async SearchGongdan() {
        this.listLoading = true
        let data = 'cmd=gd_list'+
          '&count='+ this.count +
          '&page='+ this.page +
          '&key_type='+ this.key_type +
          '&keyword='+ this.search +
          '&orderby='+ this.orderby +
          '&ordertype='+ this.ordertype
        let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',data)
        if(vueData.response == 200 ) {
          let t = Number(vueData.MyTimeSpan)
          this.total = vueData.msg.allcount
          this.gongdanList = vueData.msg.content.map((item, index) => {
            let type,state,cbtn
            let ctime = ''
            switch (item.gd_type) {
              case 'domain':
                type = '域名';
                break;
              case 'vhost':
                type = '虚拟主机';
                break;
              case 'vps':
                type = '云服务器';
                break;
              case 'beian':
                type = '网站备案';
                break;
              case 'account':
                type = '账号与财务';
                break
            }
            switch (item.gd_state) {
              case '0':
                state = '待分配'
                break
              case '1':
                state = '处理中'
                break
              case '2':
                state = '已答复'
                break
              case '3':
                state = '已结束'
                break
            }
            if(item.ReminderDate != null) {
              ctime = item.ReminderDate
              cbtn = false
            }else {
              if((Date.now() -60000*t) > Date.parse(item.gd_time.replace(/-/g,"/"))) {
                cbtn = true
              }else {
                cbtn = false
              }
            }
            return {
              id:item.id,
              content:item.gd_content,
              type:type,
              time:item.gd_time,
              state:state,
              ctime:ctime,
              cbtn:cbtn
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      sort(obj){
        switch (obj.prop) {
          case 'time':
            this.orderby = 'gd_time'
            break
          case 'state':
            this.orderby = 'gd_state'
            break
        }
        switch (obj.order) {
          case 'ascending':
            this.ordertype = 'asc'
            break
          case 'descending':
            this.ordertype = 'desc'
            break
        }
        this.SearchGongdan()
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchGongdan()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchGongdan()
      },
      submitGongdan(){
        this.$router.push('/fuwu')
      },
      Chakan(id){
        this.$router.push('/fuwu3/'+ id)
      },
      Cuidan(id) {
        MessageBox.confirm('您确定催单么?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=gd_reminder'+
            '&id_root=' + id
          this.dialogLoading = true
          let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.SearchGongdan()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        })
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .input-with-select .el-input-group__prepend .el-select {
    width: 100px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fuwu/fuwu2.vue